/* Guided fragrance finder UI. Recommendations are produced by TMFragrance. */
(() => {
  'use strict';

  const tmCopy = {"Floral":["Blumig","Floreale","Floral"],"Gourmand":["Gourmand","Gourmand","Gourmand"],"Boisé":["Holzig","Legnoso","Woody"],"Frais":["Frisch","Fresco","Fresh"],"Agrumes":["Zitrus","Agrumi","Citrus"],"Fruité":["Fruchtig","Fruttato","Fruity"],"Oriental":["Orientalisch","Orientale","Oriental"],"Épicé":["Würzig","Speziato","Spicy"],"Musqué":["Moschus","Muschiato","Musky"],"Vanillé":["Vanille","Vanigliato","Vanilla"],"Ambré":["Amber","Ambrato","Amber"],"Discret":["Dezent","Discreto","Subtle"],"Équilibré":["Ausgewogen","Equilibrato","Balanced"],"Intense":["Intensiv","Intenso","Intense"],"Au quotidien":["Im Alltag","Ogni giorno","Everyday"],"En soirée":["Am Abend","La sera","Evening"],"Pour offrir":["Als Geschenk","Da regalare","As a gift"],"En voyage":["Auf Reisen","In viaggio","For travel"],"Quelles senteurs vous attirent ?":["Welche Düfte mögen Sie?","Quali profumi Le piacciono?","Which scents appeal to you?"],"Floral · fleurs":["Blumig · Blüten","Floreale · fiori","Floral · flowers"],"Gourmand · sucré":["Gourmand · süss","Gourmand · dolce","Gourmand · sweet"],"Boisé · bois":["Holzig · Hölzer","Legnoso · legni","Woody · woods"],"Frais · agrumes":["Frisch · Zitrus","Fresco · agrumi","Fresh · citrus"],"Oriental · épices":["Orientalisch · Gewürze","Orientale · spezie","Oriental · spices"],"Je ne sais pas encore":["Ich weiss es noch nicht","Non lo so ancora","I’m not sure yet"],"Quel sillage préférez-vous ?":["Welche Duftintensität bevorzugen Sie?","Quale intensità preferisce?","How strong a scent trail do you prefer?"],"Le sillage est la présence du parfum autour de vous.":["Die Duftspur beschreibt, wie stark ein Parfum um Sie herum wahrnehmbar ist.","La scia è la presenza del profumo intorno a Lei.","The scent trail is how noticeable the fragrance is around you."],"Sans préférence":["Keine Präferenz","Nessuna preferenza","No preference"],"Pour quelle occasion ?":["Für welchen Anlass?","Per quale occasione?","For which occasion?"],"Peu importe":["Beliebig","È indifferente","Any occasion"],"Quel budget maximal souhaitez-vous respecter ?":["Wie hoch ist Ihr maximales Budget?","Qual è il Suo budget massimo?","What is your maximum budget?"],"Pas de maximum":["Kein Höchstbetrag","Nessun limite massimo","No maximum"],"Désactiver le conseil IA":["KI-Beratung deaktivieren","Disattivare i consigli IA","Turn off AI advice"],"Activer le conseil IA":["KI-Beratung aktivieren","Attivare i consigli IA","Turn on AI advice"],"Le conseil IA affine vos suggestions…":["Die KI-Beratung verfeinert Ihre Vorschläge…","L’IA sta affinando i suggerimenti…","AI advice is refining your suggestions…"],"Le guide local reste actif pour cette suggestion.":["Für diesen Vorschlag bleibt der lokale Ratgeber aktiv.","La guida locale resta attiva per questo suggerimento.","The local guide remains active for this suggestion."],"Le conseil IA est indisponible. Le guide local continue.":["Die KI-Beratung ist nicht verfügbar. Der lokale Ratgeber bleibt aktiv.","I consigli IA non sono disponibili. La guida locale continua.","AI advice is unavailable. The local guide continues."],"Votre sélection est prête. Vous pouvez encore préciser vos goûts ci-dessous.":["Ihre Auswahl ist bereit. Sie können Ihre Vorlieben unten weiter präzisieren.","La Sua selezione è pronta. Può ancora precisare i Suoi gusti qui sotto.","Your selection is ready. You can refine your preferences below."],"♡ J’aime":["♡ Gefällt mir","♡ Mi piace","♡ I like it"],"× Pas pour moi":["× Nicht für mich","× Non fa per me","× Not for me"],"○ À découvrir":["○ Entdecken","○ Da scoprire","○ To discover"],"Ce parfum a été retiré de vos suggestions.":["Dieses Parfum wurde aus Ihren Vorschlägen entfernt.","Questo profumo è stato rimosso dai suggerimenti.","This fragrance has been removed from your suggestions."],"Votre retour a été pris en compte pour cette page.":["Ihre Rückmeldung wurde für diese Seite berücksichtigt.","Il Suo feedback è stato preso in considerazione per questa pagina.","Your feedback has been taken into account for this page."],"Voir le parfum":["Parfum ansehen","Vedere il profumo","View fragrance"],"Je cherche une suggestion…":["Ein Vorschlag wird gesucht…","Ricerca di un suggerimento…","Finding a suggestion…"],"Aucun parfum ne correspond exactement pour le moment.":["Zurzeit entspricht kein Parfum genau Ihren Wünschen.","Al momento nessun profumo corrisponde esattamente alle Sue preferenze.","No fragrance is an exact match at the moment."],"Modifiez votre budget ou annulez votre dernier choix pour élargir la sélection.":["Ändern Sie Ihr Budget oder machen Sie Ihre letzte Auswahl rückgängig, um die Auswahl zu erweitern.","Modifichi il budget o annulli l’ultima scelta per ampliare la selezione.","Change your budget or undo your last choice to broaden the selection."],"Vous avez parcouru cette sélection.":["Sie haben diese Auswahl durchgesehen.","Ha esaminato questa selezione.","You have browsed this selection."],"Annulez votre dernier choix ou précisez vos goûts pour obtenir une nouvelle suggestion.":["Machen Sie Ihre letzte Auswahl rückgängig oder präzisieren Sie Ihre Vorlieben, um einen neuen Vorschlag zu erhalten.","Annulli l’ultima scelta o precisi i Suoi gusti per ottenere un nuovo suggerimento.","Undo your last choice or refine your preferences to get a new suggestion."],"Une première découverte du catalogue":["Ein erster Einblick in den Katalog","Una prima scoperta del catalogo","A first discovery from the catalogue"],"Le guide ne peut pas afficher les suggestions pour le moment.":["Der Ratgeber kann zurzeit keine Vorschläge anzeigen.","La guida non può mostrare suggerimenti al momento.","The guide cannot display suggestions at the moment."],"Vous pouvez continuer à parcourir la boutique normalement.":["Sie können den Shop weiterhin wie gewohnt besuchen.","Può continuare a navigare nel negozio normalmente.","You can continue browsing the shop as usual."],"Votre précision":["Ihre Angaben","La Sua precisazione","Your details"],"Indiquez une envie de parfum, par exemple « boisé » ou « jusqu’à CHF 50 ».":["Beschreiben Sie Ihren Duftwunsch, zum Beispiel «holzig» oder «bis CHF 50».","Indichi una preferenza, ad esempio «legnoso» o «fino a CHF 50».","Describe a fragrance preference, for example “woody” or “up to CHF 50”."],"Je n’ai pas reconnu cette précision. Essayez par exemple « boisé, discret, sans vanille, jusqu’à CHF 50 ».":["Diese Angabe wurde nicht erkannt. Versuchen Sie zum Beispiel «holzig, dezent, ohne Vanille, bis CHF 50».","Non ho riconosciuto questa precisazione. Provi ad esempio «legnoso, discreto, senza vaniglia, fino a CHF 50».","I didn’t recognise these details. Try “woody, subtle, without vanilla, up to CHF 50”, for example."],"Dernier choix annulé.":["Letzte Auswahl rückgängig gemacht.","Ultima scelta annullata.","Last choice undone."],"Le profil a été effacé de cette page et du stockage local.":["Das Profil wurde von dieser Seite und aus dem lokalen Speicher gelöscht.","Il profilo è stato cancellato da questa pagina e dalla memoria locale.","The profile has been cleared from this page and local storage."],"Vos préférences et vos prochains choix seront mémorisés sur cet appareil pendant 30 jours.":["Ihre Vorlieben und Ihre nächsten Entscheidungen werden 30 Tage lang auf diesem Gerät gespeichert.","Le Sue preferenze e le prossime scelte saranno memorizzate su questo dispositivo per 30 giorni.","Your preferences and future choices will be saved on this device for 30 days."],"Activez d’abord les cookies de préférences, puis choisissez à nouveau « Mémoriser ».":["Aktivieren Sie zuerst die Präferenz-Cookies und wählen Sie dann erneut «Speichern».","Attivi prima i cookie delle preferenze, poi selezioni di nuovo «Memorizzare».","Enable preference cookies first, then select “Remember” again."],"La mémorisation n’est pas disponible sur cet appareil. Le guide continue de fonctionner sur cette page.":["Das Speichern ist auf diesem Gerät nicht verfügbar. Der Ratgeber funktioniert auf dieser Seite weiterhin.","La memorizzazione non è disponibile su questo dispositivo. La guida continua a funzionare su questa pagina.","Saving is unavailable on this device. The guide continues to work on this page."],"Le conseil IA est activé pour cette page.":["Die KI-Beratung ist für diese Seite aktiviert.","I consigli IA sono attivi per questa pagina.","AI advice is enabled for this page."],"Le guide local est actif.":["Der lokale Ratgeber ist aktiv.","La guida locale è attiva.","The local guide is active."],"La mémorisation est désactivée. Vos choix restent actifs sur cette page.":["Das Speichern ist deaktiviert. Ihre Auswahl bleibt auf dieser Seite aktiv.","La memorizzazione è disattivata. Le Sue scelte restano attive su questa pagina.","Saving is disabled. Your choices remain active on this page."],"Le guide est momentanément indisponible.":["Der Ratgeber ist vorübergehend nicht verfügbar.","La guida è momentaneamente non disponibile.","The guide is temporarily unavailable."],"Jusqu’à CHF [[0]].–":["Bis CHF [[0]].–","Fino a CHF [[0]].–","Up to CHF [[0]].–"],"à éviter : [[0]]":["vermeiden: [[0]]","da evitare: [[0]]","to avoid: [[0]]"],"intensité : [[0]]":["Intensität: [[0]]","intensità: [[0]]","intensity: [[0]]"],"occasion : [[0]]":["Anlass: [[0]]","occasione: [[0]]","occasion: [[0]]"],"budget : jusqu’à CHF [[0]].–":["Budget: bis CHF [[0]].–","budget: fino a CHF [[0]].–","budget: up to CHF [[0]].–"],"Je retiens : [[0]].":["Ich berücksichtige: [[0]].","Tengo conto di: [[0]].","I’ll use: [[0]]."],"Notes indiquées : [[0]].":["Angegebene Duftnoten: [[0]].","Note indicate: [[0]].","Listed notes: [[0]]."],"Étape [[0]] sur [[1]]":["Schritt [[0]] von [[1]]","Passaggio [[0]] di [[1]]","Step [[0]] of [[1]]"],"Voir [[0]]":["[[0]] ansehen","Vedere [[0]]","View [[0]]"],"1 suggestion parmi [[0]]":["1 Vorschlag von [[0]]","1 suggerimento su [[0]]","1 suggestion out of [[0]]"],"Conversation avec le conseiller parfum":["Gespräch mit dem Duftberater","Conversazione con il consulente di profumi","Conversation with the fragrance advisor"],"Annuler le dernier choix":["Letzte Auswahl rückgängig machen","Annullare l’ultima scelta","Undo last choice"],"Recommencer":["Neu beginnen","Ricominciare","Start again"],"Mémoriser":["Speichern","Memorizzare","Remember"],"Vos réponses restent sur cette page. La mémorisation est facultative et demande votre accord pour les cookies de préférences.":["Ihre Antworten bleiben auf dieser Seite. Das Speichern ist freiwillig und erfordert Ihre Zustimmung zu Präferenz-Cookies.","Le Sue risposte restano su questa pagina. La memorizzazione è facoltativa e richiede il consenso ai cookie delle preferenze.","Your answers stay on this page. Saving is optional and requires your consent to preference cookies."],"Ce guide interactif nécessite JavaScript. Vous pouvez continuer à parcourir toutes les collections et fiches produit de la boutique.":["Dieser interaktive Ratgeber benötigt JavaScript. Sie können weiterhin alle Kollektionen und Produktseiten des Shops besuchen.","Questa guida interattiva richiede JavaScript. Può continuare a consultare tutte le collezioni e le schede prodotto del negozio.","This interactive guide requires JavaScript. You can continue browsing all collections and product pages in the shop."]};
  function tmSay(source, ...values) {
    const lang = typeof document === "undefined" ? "fr" : document.documentElement.lang.split("-")[0];
    const index = ["de", "it", "en"].indexOf(lang);
    return (tmCopy[source]?.[index] ?? source).replace(/\[\[(\d+)\]\]/g, (_, i) => String(values[Number(i)] ?? ""));
  }


  const LABELS = {
    floral: tmSay("Floral"), gourmand: tmSay("Gourmand"), boise: tmSay("Boisé"), frais: tmSay("Frais"),
    agrume: tmSay("Agrumes"), fruite: tmSay("Fruité"), oriental: tmSay("Oriental"), epice: tmSay("Épicé"),
    musque: tmSay("Musqué"), vanille: tmSay("Vanillé"), ambre: tmSay("Ambré"),
    leger: tmSay("Discret"), equilibre: tmSay("Équilibré"), intense: tmSay("Intense"),
    quotidien: tmSay("Au quotidien"), soiree: tmSay("En soirée"), cadeau: tmSay("Pour offrir"), voyage: tmSay("En voyage"),
  };
  const ADVISOR_TIMEOUT_MS = 8000;
  const MAX_ANALYTICS_EVENTS_PER_PAGE = 50;
  const analyticsSignals = new Set();
  const ADVISOR_PROFILE_KEYS = ['families', 'excludedFamilies', 'notes', 'excludedNotes', 'liked', 'disliked'];
  const ALLOWED_LOCALES = new Set(['fr', 'en', 'de', 'it']);

  const QUESTIONS = [
    {
      text: tmSay("Quelles senteurs vous attirent ?"),
      options: [
        [tmSay("Floral · fleurs"), {families: ['floral']}],
        [tmSay("Gourmand · sucré"), {families: ['gourmand']}],
        [tmSay("Boisé · bois"), {families: ['boise']}],
        [tmSay("Frais · agrumes"), {families: ['frais', 'agrume']}],
        [tmSay("Oriental · épices"), {families: ['oriental', 'epice']}],
        [tmSay("Je ne sais pas encore"), {}],
      ],
    },
    {
      text: tmSay("Quel sillage préférez-vous ?"),
      help: tmSay("Le sillage est la présence du parfum autour de vous."),
      options: [
        [tmSay("Discret"), {intensity: 'leger'}],
        [tmSay("Équilibré"), {intensity: 'equilibre'}],
        [tmSay("Intense"), {intensity: 'intense'}],
        [tmSay("Sans préférence"), {}],
      ],
    },
    {
      text: tmSay("Pour quelle occasion ?"),
      options: [
        [tmSay("Au quotidien"), {occasions: ['quotidien']}],
        [tmSay("En soirée"), {occasions: ['soiree']}],
        [tmSay("Pour offrir"), {occasions: ['cadeau']}],
        [tmSay("Peu importe"), {}],
      ],
    },
    {
      text: tmSay("Quel budget maximal souhaitez-vous respecter ?"),
      options: [
        ['CHF 35.–', {budgetMax: 3500}],
        ['CHF 50.–', {budgetMax: 5000}],
        ['CHF 75.–', {budgetMax: 7500}],
        ['CHF 100.–', {budgetMax: 10000}],
        [tmSay("Pas de maximum"), {budgetMax: null}],
      ],
    },
  ];

  function waitForEngine(timeout = 8000) {
    if (window.TMFragrance?.ready) return window.TMFragrance.ready;
    return new Promise((resolve, reject) => {
      const started = Date.now();
      const onReady = (event) => {
        if (event.detail?.status !== 'ready' || !window.TMFragrance) return;
        cleanup();
        resolve(window.TMFragrance);
      };
      const timer = window.setInterval(() => {
        if (window.TMFragrance?.ready) {
          cleanup();
          window.TMFragrance.ready.then(resolve);
        } else if (Date.now() - started > timeout) {
          cleanup();
          reject(new Error('TMFragrance unavailable'));
        }
      }, 80);
      const cleanup = () => {
        window.clearInterval(timer);
        window.removeEventListener('tm:fragrance-profile', onReady);
      };
      window.addEventListener('tm:fragrance-profile', onReady);
    });
  }

  function node(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text != null) element.textContent = text;
    return element;
  }

  function labelList(values) {
    return (values || []).map((value) => LABELS[value] || value).join(' · ');
  }

  function answerLabel(patch, fallback) {
    if (patch.budgetMax != null) return tmSay("Jusqu’à CHF [[0]].–", (patch.budgetMax / 100).toFixed(0));
    if (Object.prototype.hasOwnProperty.call(patch, 'budgetMax')) return tmSay("Pas de maximum");
    return labelList(patch.families || patch.notes || patch.occasions || [patch.intensity]) || fallback;
  }

  function parsedReply(parsed) {
    const parts = [];
    const positive = [...new Set([...(parsed.notes || []), ...(parsed.families || [])])];
    const excluded = [...new Set([...(parsed.excludedNotes || []), ...(parsed.excludedFamilies || [])])];
    if (positive.length) parts.push(labelList(positive));
    if (excluded.length) parts.push(tmSay("à éviter : [[0]]", labelList(excluded)));
    if (parsed.intensity) parts.push(tmSay("intensité : [[0]]", LABELS[parsed.intensity] || parsed.intensity));
    if ((parsed.occasions || []).length) parts.push(tmSay("occasion : [[0]]", labelList(parsed.occasions)));
    if (Object.prototype.hasOwnProperty.call(parsed, 'budgetMax')) {
      parts.push(tmSay("budget : jusqu’à CHF [[0]].–", (Number(parsed.budgetMax) / 100).toFixed(0)));
    }
    return parts.length ? tmSay("Je retiens : [[0]].", parts.join(' ; ')) : '';
  }

  function isSimpleGreeting(value) {
    const text = String(value || '').toLocaleLowerCase('fr').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    return /^(bonjour|bonsoir|salut|coucou|merci|merci beaucoup|hallo|guten tag|guten abend|danke|vielen dank|ciao|buongiorno|buonasera|grazie|hello|hi|good morning|good evening|thanks|thank you)[!,. ]*$/.test(text);
  }

  function nextUnansweredQuestionIndex(answeredSteps) {
    return QUESTIONS.findIndex((_question, index) => !answeredSteps.has(index));
  }

  function productDescriptors(product) {
    if (product.notes) {
      return [...new Set(
        product.notes
          .split(/[•·,;|\n]/)
          .map((item) => item.trim().replace(/^[-–—]\s*/, ''))
          .filter(Boolean)
      )].slice(0, 4);
    }
    const source = [...(product.families || []), ...(product.tags || [])];
    const normalized = source.map((value) => String(value).toLocaleLowerCase('fr'));
    return Object.keys(LABELS)
      .filter((key) => normalized.some((value) => value.includes(key) || value.includes(LABELS[key].toLocaleLowerCase('fr'))))
      .map((key) => LABELS[key])
      .slice(0, 4);
  }

  function productDescription(product) {
    const summary = String(product.summary || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    if (summary && summary.length <= 200) return summary;

    const chronologyStart = summary.search(/\b(?:lancé(?:e)?|créé(?:e)?|fondé(?:e)?)\s+en\b/i);
    if (chronologyStart >= 24) {
      const lead = summary.slice(0, chronologyStart).replace(/[,:;–—-]\s*$/, '').trim();
      if (lead.length >= 24 && lead.length <= 200) return lead;
    }

    const firstSentence = summary.match(/^.+?[.!?](?=\s|$)/)?.[0]?.trim();
    if (firstSentence && firstSentence.length <= 200) return firstSentence;

    if (summary) return `${summary.slice(0, 200).replace(/\s+\S*$/, '').trimEnd()}…`;
    const notes = productDescriptors(product);
    return notes.length ? tmSay("Notes indiquées : [[0]].", notes.join(', ')) : '';
  }

  function productVariantUrl(product, variant) {
    const base = product.url || '#';
    if (!variant?.id) return base;
    const separator = base.includes('?') ? '&' : '?';
    return `${base}${separator}variant=${encodeURIComponent(variant.id)}`;
  }

  function allowedEndpoint(value, fixedPath) {
    try {
      const raw = String(value ?? '').trim();
      if (!raw) return '';
      const endpoint = new URL(raw, window.location.href);
      if (
        endpoint.pathname !== fixedPath ||
        endpoint.search !== '' ||
        endpoint.hash !== '' ||
        endpoint.username !== '' ||
        endpoint.password !== ''
      ) return '';
      if (endpoint.protocol === 'https:') return endpoint.href;
      const localHost = window.location.hostname;
      const isLoopback = localHost === 'localhost' || localHost === '127.0.0.1' || localHost === '::1';
      if (
        endpoint.protocol === 'http:' &&
        isLoopback &&
        endpoint.hostname === localHost &&
        endpoint.pathname === fixedPath
      ) return endpoint.href;
      return '';
    } catch (_error) {
      return '';
    }
  }

  function advisorLocale() {
    const locale = String(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
    return ALLOWED_LOCALES.has(locale) ? locale : 'fr';
  }

  function limitedValues(values) {
    return [...new Set((Array.isArray(values) ? values : []).map(String).filter(Boolean))].slice(0, 30);
  }

  function minimizedAdvisorProfile(profile) {
    const minimal = {};
    ADVISOR_PROFILE_KEYS.forEach((key) => {
      const values = limitedValues(profile?.[key]);
      if (values.length) minimal[key] = values;
    });
    const budget = profile?.budgetMax;
    if (budget === null || budget === undefined || budget === '') {
      minimal.budgetMax = null;
    } else if (Number.isInteger(Number(budget)) && Number(budget) >= 0) {
      minimal.budgetMax = Number(budget);
    }
    return minimal;
  }

  function advisorProfilePatch(raw) {
    if (!raw || typeof raw !== 'object') return {};
    const patch = {};
    ['families', 'excludedFamilies', 'notes', 'excludedNotes'].forEach((key) => {
      const values = limitedValues(raw[key]).filter((value) => value.length <= 100);
      if (values.length) patch[key] = values;
    });
    if (raw.budgetMax === null || (Number.isInteger(Number(raw.budgetMax)) && Number(raw.budgetMax) >= 0 && Number(raw.budgetMax) <= 1000000)) {
      patch.budgetMax = raw.budgetMax === null ? null : Number(raw.budgetMax);
    }
    return patch;
  }

  function analyticsAllowed() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.analyticsProcessingAllowed?.() === true && privacy?.currentVisitorConsent?.().analytics === 'yes';
    } catch (_error) {
      return false;
    }
  }

  function budgetBand(value) {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return 'no_maximum';
    if (amount <= 3500) return 'up_to_35';
    if (amount <= 5000) return 'up_to_50';
    if (amount <= 7500) return 'up_to_75';
    if (amount <= 10000) return 'up_to_100';
    return 'over_100';
  }

  function publishSignal(endpoint, payload) {
    if (!analyticsAllowed()) return;
    const key = JSON.stringify(payload);
    if (analyticsSignals.has(key) || analyticsSignals.size >= MAX_ANALYTICS_EVENTS_PER_PAGE) return;
    analyticsSignals.add(key);
    try {
      window.Shopify?.analytics?.publish?.('parfum4you:fragrance_signal', payload);
    } catch (_error) {
      // Publishing is optional: the guide must never depend on a pixel or collector.
    }
    if (!endpoint) return;
    fetch(endpoint, {
      method: 'POST',
      credentials: 'omit',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({consent: true, event: payload}),
    }).catch(() => {});
  }

  function publishPreferenceSignals(endpoint, patch, source) {
    (patch?.notes || []).forEach((value) => publishSignal(endpoint, {
      schema_version: 1, signal: 'preference_selected', category: 'note', value: String(value), source,
    }));
    if (Object.prototype.hasOwnProperty.call(patch || {}, 'budgetMax')) {
      publishSignal(endpoint, {
        schema_version: 1, signal: 'preference_selected', category: 'budget_band', value: budgetBand(patch.budgetMax), source,
      });
    }
  }

  function initializeFinder(root, engine) {
    if (root.dataset.tmFinderReady === 'true') return;
    root.dataset.tmFinderReady = 'true';

    const conversation = root.querySelector('[data-finder-conversation]');
    const results = root.querySelector('[data-finder-results]');
    const resultStatus = root.querySelector('[data-finder-result-status]');
    const form = root.querySelector('[data-finder-text-form]');
    const input = root.querySelector('[data-finder-text-input]');
    const freeText = root.querySelector('.tm-finder__free-text');
    const undoButton = root.querySelector('[data-finder-undo]');
    const resetButton = root.querySelector('[data-finder-reset]');
    const rememberButton = root.querySelector('[data-finder-remember]');
    const memoryStatus = root.querySelector('[data-finder-memory-status]');
    const advisorButton = root.querySelector('[data-finder-ai-toggle]');
    const advisorStatus = root.querySelector('[data-finder-ai-status]');
    const advisorEndpoint = allowedEndpoint(root.dataset.tmAdvisorEndpoint, '/api/advisor');
    const analyticsEndpoint = allowedEndpoint(root.dataset.tmAnalyticsEndpoint, '/api/events');
    const completeCopy = root.dataset.completeCopy || tmSay("Votre sélection est prête. Vous pouvez encore préciser vos goûts ci-dessous.");

    let step = 0;
    let answers = [];
    let history = [];
    let answeredSteps = new Set();
    let reviewedProducts = new Set();
    let renderToken = 0;
    let advisorEnabled = false;
    let advisorRequest = null;
    let advisorError = false;
    let advisorReply = '';
    let lastAdvisorPatch = '';
    let baselineProfile = engine.getProfile();

    function setAdvisorStatus(message) {
      if (advisorStatus) advisorStatus.textContent = message;
    }

    function updateAdvisorButton() {
      if (!advisorButton) return;
      advisorButton.textContent = advisorEnabled ? tmSay("Désactiver le conseil IA") : root.dataset.aiActivateLabel || tmSay("Activer le conseil IA");
      advisorButton.setAttribute('aria-pressed', advisorEnabled ? 'true' : 'false');
    }

    async function advisorProvider({profile}) {
      if (!advisorEnabled || !advisorEndpoint) return [];
      advisorRequest?.abort();
      const controller = new AbortController();
      advisorRequest = controller;
      const timer = window.setTimeout(() => controller.abort(), ADVISOR_TIMEOUT_MS);
      advisorError = false;
      advisorReply = '';
      setAdvisorStatus(tmSay("Le conseil IA affine vos suggestions…"));
      try {
        const response = await fetch(advisorEndpoint, {
          method: 'POST',
          credentials: 'omit',
          headers: {'Content-Type': 'application/json'},
          signal: controller.signal,
          body: JSON.stringify({
            profile: minimizedAdvisorProfile(profile),
            message: String(profile?.freeText || '').slice(0, 500),
            locale: advisorLocale(),
          }),
        });
        if (!response.ok) throw new Error(`advisor request failed: ${response.status}`);
        const data = await response.json();
        if (!Array.isArray(data?.recommendations)) throw new Error('advisor response is invalid');
        const profilePatch = advisorProfilePatch(data.profilePatch);
        const hasExplicitBudget = answers.some((answer) => Object.prototype.hasOwnProperty.call(answer.patch || {}, 'budgetMax'));
        if (hasExplicitBudget) delete profilePatch.budgetMax;
        const patchKey = JSON.stringify(profilePatch);
        if (patchKey !== '{}' && patchKey !== lastAdvisorPatch) {
          lastAdvisorPatch = patchKey;
          engine.update(profilePatch, {source: 'advisor-profile-patch'});
        }
        if (data.fallback === true) {
          setAdvisorStatus(tmSay("Le guide local reste actif pour cette suggestion."));
          return [];
        }
        advisorReply = typeof data.reply === 'string' ? data.reply.slice(0, 500) : '';
        return data.recommendations.slice(0, 3).filter((id) => typeof id === 'string' || typeof id === 'number');
      } catch (_error) {
        if (!controller.signal.aborted) advisorError = true;
        setAdvisorStatus(tmSay("Le conseil IA est indisponible. Le guide local continue."));
        throw _error;
      } finally {
        window.clearTimeout(timer);
        if (advisorRequest === controller) advisorRequest = null;
      }
    }

    function snapshot() {
      return {
        profile: engine.getProfile(),
        step,
        answers: JSON.parse(JSON.stringify(answers)),
        reviewedProducts: [...reviewedProducts],
        answeredSteps: [...answeredSteps],
      };
    }

    function nextUnansweredStep() {
      const next = nextUnansweredQuestionIndex(answeredSteps);
      step = next === -1 ? QUESTIONS.length : next;
    }

    function markStepsFromText(parsed) {
      if ((parsed.families || []).length || (parsed.excludedFamilies || []).length || (parsed.notes || []).length || (parsed.excludedNotes || []).length) answeredSteps.add(0);
      if (parsed.intensity) answeredSteps.add(1);
      if ((parsed.occasions || []).length) answeredSteps.add(2);
      if (Object.prototype.hasOwnProperty.call(parsed, 'budgetMax')) answeredSteps.add(3);
      nextUnansweredStep();
    }

    function removeAnswer(answerIndex) {
      const removed = answers[answerIndex];
      if (!removed || removed.kind === 'conversation') return;
      history.push(snapshot());
      const current = engine.getProfile();
      const keepFeedback = (key) => [...new Set([...(baselineProfile[key] || []), ...(current[key] || [])])];
      engine.setProfile({
        ...baselineProfile,
        liked: keepFeedback('liked'),
        disliked: keepFeedback('disliked'),
        discover: keepFeedback('discover'),
        families: [...(baselineProfile.families || [])],
        excludedFamilies: [...(baselineProfile.excludedFamilies || [])],
        notes: [...(baselineProfile.notes || [])],
        excludedNotes: [...(baselineProfile.excludedNotes || [])],
        occasions: [...(baselineProfile.occasions || [])],
        intensity: baselineProfile.intensity,
        budgetMax: baselineProfile.budgetMax,
        freeText: baselineProfile.freeText || '',
      }, {source: 'answer-removed'});
      const remaining = answers.filter((_answer, index) => index !== answerIndex);
      answeredSteps = new Set();
      answers = remaining;
      remaining.forEach((answer) => {
        if (!answer.patch) return;
        engine.update(answer.patch, {source: 'answer-replay'});
        if (answer.kind === 'guided' && Number.isInteger(answer.step)) answeredSteps.add(answer.step);
        else markStepsFromText(answer.patch);
      });
      nextUnansweredStep();
      renderConversation();
    }

    function renderConversation() {
      conversation.replaceChildren();

      const question = QUESTIONS[step];
      if (!question) {
        conversation.append(node('p', 'tm-finder__completion', completeCopy));
      } else {
        conversation.append(node('p', 'tm-finder__progress', tmSay("Étape [[0]] sur [[1]]", step + 1, QUESTIONS.length)));
        conversation.append(node('p', 'tm-finder__question', question.text));
        if (question.help) conversation.append(node('p', 'tm-finder__question-help', question.help));
        const options = node('div', 'tm-finder__choices');
        question.options.forEach(([label, patch]) => {
          const button = node('button', 'tm-finder__choice', label);
          button.type = 'button';
          button.addEventListener('click', () => {
            history.push(snapshot());
            const answer = answerLabel(patch, label);
            answers.push({kind: 'guided', question: question.text, label: answer, patch, step, reply: tmSay("Je retiens : [[0]].", answer)});
            publishPreferenceSignals(analyticsEndpoint, patch, 'guided');
            engine.update(patch, {source: 'guided-answer'});
            answeredSteps.add(step);
            nextUnansweredStep();
            renderConversation();
          });
          options.append(button);
        });
        conversation.append(options);
      }

      undoButton.disabled = history.length === 0;
      rememberButton.disabled = !engine.hasPreferences();
    }

    function renderEmpty(message) {
      results.replaceChildren(node('p', 'tm-finder__results-empty', message));
    }

    function createProductCard(entry) {
      const {product, variant} = entry;
      const card = node('article', 'tm-finder-card');
      card.dataset.productKey = String(product.id || product.handle);
      const destination = productVariantUrl(product, variant);

      const mediaLink = node('a', 'tm-finder-card__media');
      mediaLink.href = destination;
      mediaLink.setAttribute('aria-label', tmSay("Voir [[0]]", product.title));
      if (product.image?.src) {
        const image = node('img', 'tm-finder-card__image');
        image.src = product.image.src;
        image.alt = product.image.alt || product.title;
        image.width = product.image.width || 720;
        image.height = product.image.height || 900;
        image.loading = 'lazy';
        mediaLink.append(image);
      }
      card.append(mediaLink);

      const body = node('div', 'tm-finder-card__body');
      body.append(node('p', 'tm-finder-card__vendor', product.vendor));
      const title = node('h3', 'tm-finder-card__title');
      const titleLink = node('a', '', product.title);
      titleLink.href = destination;
      title.append(titleLink);
      body.append(title);

      const description = productDescription(product);
      if (description) body.append(node('p', 'tm-finder-card__description', description));

      const price = node('p', 'tm-finder-card__price', variant?.priceFormatted || product.priceFormatted || '');
      body.append(price);
      if (variant?.title && !/^default title$/i.test(variant.title)) {
        body.append(node('p', 'tm-finder-card__variant', variant.title));
      }

      const descriptors = productDescriptors(product);
      if (descriptors.length) {
        const tags = node('ul', 'tm-finder-card__tags');
        descriptors.forEach((descriptor) => tags.append(node('li', '', descriptor)));
        body.append(tags);
      }

      const actions = node('div', 'tm-finder-card__feedback');
      [
        [tmSay("♡ J’aime"), 'like'],
        [tmSay("× Pas pour moi"), 'dislike'],
        [tmSay("○ À découvrir"), 'discover'],
      ].forEach(([label, action]) => {
        const button = node('button', 'tm-finder-card__feedback-button', label);
        button.type = 'button';
        button.dataset.action = action;
        button.addEventListener('click', () => {
          history.push(snapshot());
          const profile = engine.getProfile();
          const key = String(product.id || product.handle);
          reviewedProducts.add(key);
          const next = {
            liked: profile.liked.filter((item) => item !== key),
            disliked: profile.disliked.filter((item) => item !== key),
            discover: profile.discover.filter((item) => item !== key),
          };
          if (action === 'like') next.liked.push(key);
          if (action === 'dislike') next.disliked.push(key);
          if (action === 'discover') next.discover.push(key);
          publishSignal(analyticsEndpoint, {
            schema_version: 1,
            signal: 'product_feedback',
            category: 'feedback',
            value: action,
            product_id: key,
            source: 'feedback',
          });
          engine.setProfile({...profile, ...next}, {source: `feedback-${action}`});
          memoryStatus.textContent = action === 'dislike' ? tmSay("Ce parfum a été retiré de vos suggestions.") : tmSay("Votre retour a été pris en compte pour cette page.");
        });
        actions.append(button);
      });

      const view = node('a', 'tm-finder-card__link', root.dataset.viewLabel || tmSay("Voir le parfum"));
      view.href = destination;
      body.append(view);
      card.append(body);
      card.append(actions);
      return card;
    }

    async function renderResults() {
      const token = ++renderToken;
      resultStatus.textContent = root.dataset.loadingLabel || tmSay("Je cherche une suggestion…");
      try {
        const ranked = await engine.recommend(3);
        if (token !== renderToken) return;
        results.replaceChildren();
        if (!ranked.length) {
          resultStatus.textContent = root.dataset.noResultLabel || tmSay("Aucun parfum ne correspond exactement pour le moment.");
          renderEmpty(root.dataset.noResultCopy || tmSay("Modifiez votre budget ou annulez votre dernier choix pour élargir la sélection."));
          return;
        }
        const visible = ranked.find((entry) => !reviewedProducts.has(String(entry.product.id || entry.product.handle)));
        if (!visible) {
          resultStatus.textContent = tmSay("Vous avez parcouru cette sélection.");
          renderEmpty(tmSay("Annulez votre dernier choix ou précisez vos goûts pour obtenir une nouvelle suggestion."));
          return;
        }
        if (advisorError) {
          resultStatus.textContent = tmSay("Le conseil IA est indisponible. Le guide local continue.");
        } else if (advisorReply) {
          resultStatus.textContent = advisorReply;
        } else {
          resultStatus.textContent = engine.hasPreferences()
            ? tmSay("1 suggestion parmi [[0]]", ranked.length)
            : tmSay("Une première découverte du catalogue");
        }
        results.append(createProductCard(visible));
      } catch (_error) {
        resultStatus.textContent = tmSay("Le guide ne peut pas afficher les suggestions pour le moment.");
        renderEmpty(tmSay("Vous pouvez continuer à parcourir la boutique normalement."));
      }
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const value = input.value.trim();
      if (!value) return;
      const parsed = engine.parse(value);
      const reply = parsedReply(parsed);
      if (reply) {
        history.push(snapshot());
        engine.update(parsed, {source: 'free-text'});
        answers.push({kind: 'free', question: tmSay("Votre précision"), label: value, patch: parsed, reply});
        markStepsFromText(parsed);
      } else if (isSimpleGreeting(value)) {
        input.setCustomValidity(tmSay("Indiquez une envie de parfum, par exemple « boisé » ou « jusqu’à CHF 50 »."));
        input.reportValidity();
      } else {
        input.setCustomValidity(tmSay("Je n’ai pas reconnu cette précision. Essayez par exemple « boisé, discret, sans vanille, jusqu’à CHF 50 »."));
        input.reportValidity();
      }
      input.value = '';
      renderConversation();
    });

    input.addEventListener('input', () => input.setCustomValidity(''));

    undoButton.addEventListener('click', () => {
      const previous = history.pop();
      if (!previous) return;
      step = previous.step;
      answers = previous.answers;
      reviewedProducts = new Set(previous.reviewedProducts || []);
      answeredSteps = new Set(previous.answeredSteps || []);
      engine.setProfile(previous.profile, {source: 'undo'});
      memoryStatus.textContent = tmSay("Dernier choix annulé.");
      renderConversation();
    });

    resetButton.addEventListener('click', () => {
      engine.reset();
      baselineProfile = engine.getProfile();
      step = 0;
      answers = [];
      history = [];
      answeredSteps = new Set();
      reviewedProducts = new Set();
      memoryStatus.textContent = tmSay("Le profil a été effacé de cette page et du stockage local.");
      renderConversation();
    });

    rememberButton.addEventListener('click', () => {
      const result = engine.remember();
      if (result.ok) {
        memoryStatus.textContent = tmSay("Vos préférences et vos prochains choix seront mémorisés sur cet appareil pendant 30 jours.");
      } else if (result.reason === 'consent') {
        memoryStatus.textContent = tmSay("Activez d’abord les cookies de préférences, puis choisissez à nouveau « Mémoriser ».");
      } else {
        memoryStatus.textContent = tmSay("La mémorisation n’est pas disponible sur cet appareil. Le guide continue de fonctionner sur cette page.");
      }
    });

    if (advisorButton && advisorEndpoint) {
      advisorButton.addEventListener('click', () => {
        advisorEnabled = !advisorEnabled;
        advisorError = false;
        advisorReply = '';
        if (advisorEnabled) {
          engine.setRecommendationProvider(advisorProvider);
          setAdvisorStatus(tmSay("Le conseil IA est activé pour cette page."));
        } else {
          advisorRequest?.abort();
          advisorRequest = null;
          engine.setRecommendationProvider(null);
          setAdvisorStatus(tmSay("Le guide local est actif."));
        }
        updateAdvisorButton();
        renderResults();
      });
      updateAdvisorButton();
    }

    engine.subscribe((detail) => {
      renderResults();
      undoButton.disabled = history.length === 0;
      rememberButton.disabled = !engine.hasPreferences();
      if (detail.source === 'consent-revoked') {
        memoryStatus.textContent = tmSay("La mémorisation est désactivée. Vos choix restent actifs sur cette page.");
      }
    });
    renderConversation();
  }

  function boot() {
    const roots = [...document.querySelectorAll('[data-tm-fragrance-finder]')];
    if (!roots.length) return;
    waitForEngine()
      .then((engine) => roots.forEach((root) => initializeFinder(root, engine)))
      .catch(() => {
        roots.forEach((root) => {
          root.querySelector('[data-finder-result-status]').textContent = tmSay("Le guide est momentanément indisponible.");
          root.querySelector('[data-finder-results]').textContent = tmSay("Vous pouvez continuer à parcourir la boutique normalement.");
        });
      });
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, {once: true});
    } else {
      boot();
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {allowedEndpoint, parsedReply, isSimpleGreeting, nextUnansweredQuestionIndex, productDescription};
  }
})();
